import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icon/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-2cad72bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about_us" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "imgel",
  fit: "cover",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "营城 | 城市空间资产经营信息平台", -1))

import { ref, onMounted, onBeforeMount } from "vue"
import { showNotify, showLoadingToast, closeToast, showConfirmDialog } from "vant"
import { aboutUsApi } from "@/api/my"
import router from "@/router"
import { useRoute } from "vue-router"

export default /*#__PURE__*/_defineComponent({
  __name: 'projectIndetail',
  setup(__props) {

const route = useRoute()
const datas = ref()
onMounted(() => {
  getDetail()
})
const getDetail = async () => {
  showLoadingToast({
    message: "加载中"
  })
  aboutUsApi().then((res: any) => {
    if (res.code == 200) {
      datas.value = res.data
      console.log(datas.value)
      closeToast()
    } else {
      closeToast()
      showNotify({ type: "danger", message: res.message })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_P = _resolveComponent("P")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("p", null, "微信公众号：" + _toDisplayString(datas.value?.wechat), 1),
    _createVNode(_component_P, null, {
      default: _withCtx(() => [
        _createTextVNode("联系方式：" + _toDisplayString(datas.value?.connection), 1)
      ]),
      _: 1
    }),
    _createElementVNode("p", null, "版本号：" + _toDisplayString(datas.value?.version), 1)
  ]))
}
}

})